// Computes a shared min-width so every status pill in a set fits the longest label and stays equal width.
// A per-char estimate is unreliable (the JP font renders full-width glyphs wider than 1em), so we measure
// the actual rendered width of each label with canvas using the Tag's label font (cap12: 400 12px Noto Sans JP)
// and take the widest, plus the Chip's horizontal padding (12px each side).
// Returns undefined when there are no labels yet (e.g. options still loading) so the Tag default applies.

// Mirror of `typography.cap12` + `fonts`; canvas font string is "{weight} {size} {family}".
const TAG_LABEL_FONT = '400 12px "Noto Sans JP", sans-serif';
const TAG_HORIZONTAL_PADDING_PX = 24;
// Fallback per full-width JP char when canvas is unavailable (e.g. jsdom in tests). Slightly generous on purpose.
const FALLBACK_CHAR_WIDTH_PX = 14;

let cachedContext: CanvasRenderingContext2D | null | undefined;

const getMeasureContext = (): CanvasRenderingContext2D | null => {
  if (cachedContext !== undefined) return cachedContext;
  const canvas = typeof document !== "undefined" ? document.createElement("canvas") : null;
  cachedContext = canvas?.getContext("2d") ?? null;
  if (cachedContext) cachedContext.font = TAG_LABEL_FONT;
  return cachedContext;
};

export const getLongestLabelMinWidth = (labels: string[]): string | undefined => {
  if (!labels || !labels.length || labels.length === 0) return undefined;
  const context = getMeasureContext();
  const widestTextPx = Math.max(...labels.map((label) => (context ? context.measureText(label).width : label.length * FALLBACK_CHAR_WIDTH_PX)));

  return `${Math.ceil(widestTextPx) + TAG_HORIZONTAL_PADDING_PX}px`;
};
